var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefix+'__sidebar'},_vm._l((_vm.selfShortcuts),function(item,index){return _c('t-button',{key:index,staticClass:"mb-2",attrs:{"type":"secondary","block":""},on:{"click":function($event){$event.stopPropagation();return _vm.$_onButtonsClick(item.onClick)}}},[_vm._v("\n    "+_vm._s(item.text)+"\n  ")])}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd30ee7e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/date-picker/panel/shortcuts-aside.vue
// module id = 564
// module chunks = 0 1 2